module.exports = __webpack_public_path__ + "static/media/muscle_front_2.48ee9899.png";